import { render } from "./addModuleOther.vue?vue&type=template&id=4fe59709&scoped=true"
import script from "./addModuleOther.vue?vue&type=script&lang=js"
export * from "./addModuleOther.vue?vue&type=script&lang=js"

import "./addModuleOther.vue?vue&type=style&index=0&id=4fe59709&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe59709"]])

export default __exports__